(function(){
  var Y='#d8ff1a';
  var st=document.createElement('style');
  st.textContent='.rad-slide__text{container-type:inline-size}.rad-line{display:block;margin:0 0 .35rem}.rad-line .rad-r{font-size:min(var(--ls,4.6cqw),88px)}.rad-line .rad-r-word{margin-right:min(calc(var(--ls,4.6cqw)*.55),48px)}.rad-line.l0{--ls:4.6cqw}.rad-line.l1{--ls:9cqw}.rad-line.l2{--ls:7.4cqw}'
  +'html body .rad-slider{background-color:#cfcbc0;background-image:linear-gradient(90deg,'+Y+' 0 3px,transparent 3px),repeating-linear-gradient(transparent 0 31px,rgba(60,100,160,.14) 31px 32px),none}'
  +'html body .rad-slider::before{opacity:.3}'
  +'html body .rad-slide__strip::after{background:'+Y+';height:5px;opacity:1}'
  +'html body .rad-slide__cta{box-shadow:5px 5px 0 '+Y+'}html body .rad-slide__cta:hover{box-shadow:7px 7px 0 '+Y+'}'
  +'html body .rad-slider__arrow{box-shadow:3px 3px 0 '+Y+'}html body .rad-slider__arrow:hover{background:'+Y+';color:#111}'
  +'html body .rad-slider__dot:nth-child(3n+2){--dc:'+Y+'}'
  +'html body .rad-r.t3{--rb:'+Y+';--rc:#111}html body .rad-r.t4{--rb:#111;--rc:'+Y+'}'
  +'html body .rad-st--code text:first-of-type{fill:#111}';
  document.head.appendChild(st);
  function ransom(el){
    var txt=el.textContent.trim(); el.textContent=''; var n=0;
    txt.split('|').forEach(function(line,li){
      var ln=document.createElement('div'); ln.className='rad-line l'+li;
      line.trim().split(/\s+/).forEach(function(w){
        var wd=document.createElement('span'); wd.className='rad-r-word';
        w.split('').forEach(function(ch){
          var s=document.createElement('span'); s.className='rad-r t'+((n*5+Math.floor(n/3))%6); s.textContent=ch; wd.appendChild(s); n++;
        });
        ln.appendChild(wd); ln.appendChild(document.createTextNode(' '));
      });
      el.appendChild(ln);
    });
  }
  function init(root){
    var slides=[].slice.call(root.querySelectorAll('.rad-slide')); if(!slides.length) return;
    root.querySelectorAll('.rad-slide__head').forEach(ransom);
    var dots=root.querySelector('.rad-slider__dots'), cur=0, timer;
    if(slides.length<2){root.classList.add('is-single')}
    slides.forEach(function(s,i){var b=document.createElement('button');b.type='button';b.className='rad-slider__dot';b.setAttribute('aria-label','Slide '+(i+1));b.addEventListener('click',function(){go(i,true)});dots.appendChild(b)});
    function go(i,user){cur=(i+slides.length)%slides.length; slides.forEach(function(s,k){s.classList.toggle('is-on',k===cur)}); [].forEach.call(dots.children,function(d,k){d.classList.toggle('is-on',k===cur)}); if(user)restart()}
    function restart(){clearInterval(timer); if(slides.length>1&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer=setInterval(function(){go(cur+1)},7500)}
    root.querySelector('[data-prev]').addEventListener('click',function(){go(cur-1,true)});
    root.querySelector('[data-next]').addEventListener('click',function(){go(cur+1,true)});
    root.addEventListener('mouseenter',function(){clearInterval(timer)}); root.addEventListener('mouseleave',restart);
    go(0); restart();
  }
  function ready(){document.querySelectorAll('.rad-slider').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
})();